import { Button, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { ActionBar } from '@/components/Layout/Layout.styled';
import { Page } from '@/components/Layout/Page/Page';
import { OnboardingGuide } from '@/components/OnboardingGuide';

import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

import { useHandleThirdPartyComplianceCheck } from '../hooks';

const ThirdPartyComplianceCheckPageComponent: React.FC = () => {
  const { t } = useTranslate();

  const { handleYesClick, handleNoClick, isPending, personalUseQuestion } =
    useHandleThirdPartyComplianceCheck();

  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'big',
        children: <OnboardingGuide />,
      }}
      progressProps={PROGRESS_STEPS.thirdPartyComplianceCheckStep}
      hasLogo
    >
      <Stack direction="column" spacing={4}>
        <Typography variant="h1" textAlign="left" mb={1}>
          {personalUseQuestion?.question}
        </Typography>
        <ActionBar>
          <Button
            {...getDataTestId(`third-party-use-yes-button`)}
            variant="outlined"
            fullWidth
            onClick={handleYesClick}
            disabled={isPending}
          >
            {t('questionDrawer.personalUsage.button.yes')}
          </Button>
          <Button
            {...getDataTestId(`third-party-use-no-button`)}
            variant="outlined"
            fullWidth
            onClick={handleNoClick}
            disabled={isPending}
          >
            {t('questionDrawer.personalUsage.button.no')}
          </Button>
        </ActionBar>
      </Stack>
    </Page>
  );
};

export default function ThirdPartyComplianceCheckPage() {
  return <ThirdPartyComplianceCheckPageComponent />;
}
